<template>
  <div>
    <div
      id="desktop-footer"
      class="footer text-white"
      :class="{ 'footer-san': storeGlobal.isSeaAndNightUrl, 'footer-landing': landingFooterStyle }"
      :style="landingFooterStyle">
      <template v-if="storeGlobal.permisos.nosotros.showed || storeGlobal.permisos.rrss.showed">
        <div class="row d-flex w-100 m-auto justify-content-center py-0 py-md-5">
          <div
            v-if="storeGlobal.permisos.nosotros.showed"
            class="order-2 order-md-first col-12 col-md-3 text-center text-md-start my-4 my-md-0">
            <div class="h5 bold h5">
              {{ footerData.us.title }}
            </div>
            <template v-for="usItem in footerData.us.items" :key="usItem">
              <div v-if="usItem.show || usItem.show == undefined" class="item h6">
                <template v-if="usItem.link">
                  <a :href="usItem.link" target="_blank">
                    {{ usItem.label }}
                  </a>
                </template>
                <template v-else>
                  <router-link :to="{ name: usItem.routeName }">
                    {{ usItem.label }}
                  </router-link>
                </template>
              </div>
            </template>
          </div>
          <div v-if="storeGlobal.permisos.rrss.showed" class="order-1 order-md-last col-12 col-md-3 my-4 my-md-0">
            <p class="bold mb-2 text-center text-md-start h5">
              {{ footerData.social.title }}
            </p>
            <div class="row w-75 mx-auto mx-md-0">
              <template v-for="social in footerData.social.items" :key="social">
                <div class="col col-sm-2 item-social">
                  <a :href="social.link" target="_blank" :aria-label="social.ariaLabel">
                    <i :class="social.icon"></i>
                  </a>
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>

      <div class="pb-4 copyright d-flex text-center px-5">
        <div v-if="storeGlobal.permisos.sponsors.showed" class="d-none d-md-block"></div>
        <div class="col-12 content">
          <div class="row">
            <div class="col text-md-start">
              <div class="itemFirstFooter text-md-start">
                <img
                  v-if="checkDomain([DOMAINS.roigarena, DOMAINS.transviago])"
                  :src="logotransvia"
                  alt="Transvia"
                  class="logo-transvia" />
                <span v-else> ©{{ agenciaStore.nombre }} {{ new Date().getFullYear() }} </span>
              </div>
            </div>
          </div>
          <div
            :class="{
              'justify-content-start': isRoigarenaDomain,
              'justify-content-center': !isRoigarenaDomain,
              'text-md-start': isRoigarenaDomain,
              'text-center': !isRoigarenaDomain,
            }"
            class="row align-items-center d-flex flex-column flex-md-row pb-3">
            <div class="col-12 col-md-auto mb-md-0">
              <div class="item">
                <a class="text-white" @click="handleAvisoLegalClick">
                  <div class="title">{{ $t('footer.copyright.legal') }}</div>
                  <span class="verticalBars d-none d-md-inline">|</span>
                </a>
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div @click="goCondicionesGenerales">
                <div class="item">
                  <span class="title">{{ $t('footer.copyright.conditions') }}</span>
                  <span class="verticalBars d-none d-md-inline">|</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div @click="goPoliticaCookies">
                <div class="item">
                  <span class="title">{{ $t('footer.copyright.cookies') }}</span>
                  <span class="verticalBars d-none d-md-inline">|</span>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-auto">
              <div @click="goPoliticaPrivacidad">
                <div class="item">
                  {{ $t('footer.copyright.privacity') }}
                  <span class="verticalBars d-none d-md-inline">|</span>
                </div>
              </div>
            </div>
            <div v-if="hasFaqs" class="col-12 col-md-auto">
              <div @click="goFAQs">
                <div class="item">
                  <span class="title">{{ $t('footer.copyright.faqs') }}</span>
                </div>
              </div>
            </div>
            <div
              v-if="!checkDomain([DOMAINS.roigarena, DOMAINS.transviago])"
              class="col-auto d-none d-md-flex ms-auto align-items-center">
              <span class="small d-flex me-2 align-items-center">Powered by</span>
              <img src="@/assets/logos/mygocu.webp" width="55" height="18" alt="mygocu" />
            </div>
            <div
              v-if="!checkDomain([DOMAINS.roigarena, DOMAINS.transviago])"
              class="col-12 d-flex d-md-none justify-content-center mt-3 align-items-center">
              <span class="small me-2 d-flex align-items-center">Powered by</span>
              <img src="@/assets/logos/mygocu.webp" width="55" height="18" alt="mygocu" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { appGlobalStore } from 'src/store_pinia/app';
  import { agenciaStoreModule } from 'src/store_pinia/agencia';
  import { facebook, instagram, twitter, youtube, linkedin, tiktok } from 'src/constants/socialMedias.js';
  import { useI18n } from 'vue-i18n';
  import { computed, ref, onBeforeMount } from 'vue';
  import HomeApiService from '@/services/api/HomeApiService';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import {
    BlogLanding,
    FAQS,
    TrabajaConNosotros,
    GruposInformacionViaje,
    AgrupacionDetalle,
  } from '@/router/RouterNames';
  import router from '@/router';
  import { viajesGrupos } from '@/store_pinia/viajesGrupo';
  import { useAgrupacionesStore } from '@/store_pinia/agrupaciones';
  import { informacionHabitacion } from '@/store_pinia/informacionHabitacion';
  import { landingFooterVars, isViajeExperienciaStyleRoute } from '@/helpers/landingStyleUtils';
  import { checkDomain, DOMAINS } from '@/helpers/domainUtils';
  import logotransvia from '@/assets/home/logotransvia.png';

  const { t } = useI18n();
  const storeGlobal = appGlobalStore();
  const agenciaStore = agenciaStoreModule();
  const loadingStore = useLoadingStore();
  const viajesGruposStore = viajesGrupos();
  const agrupacionesStore = useAgrupacionesStore();
  const storeHabitacion = informacionHabitacion();

  const landingFooterStyle = computed(() => {
    if (router.currentRoute.value.name === GruposInformacionViaje) {
      return landingFooterVars(viajesGruposStore.getViajeSeleccionado?.style);
    }
    if (router.currentRoute.value.name === AgrupacionDetalle) {
      return landingFooterVars(agrupacionesStore.getAgrupacion?.style);
    }
    if (isViajeExperienciaStyleRoute(router.currentRoute.value.name)) {
      return landingFooterVars(storeHabitacion.getViaje?.style || viajesGruposStore.getViajeSeleccionado?.style);
    }
    return null;
  });

  const isRoigarenaDomain = computed(() => checkDomain([DOMAINS.roigarena]));

  const hasFaqs = ref(false);

  onBeforeMount(async () => {
    try {
      loadingStore.show();
      const faqs = await HomeApiService.getFaqs();
      hasFaqs.value = faqs?.length > 0;
    } catch {
      hasFaqs.value = false;
    } finally {
      loadingStore.hide();
    }
  });

  const footerData = computed(() => {
    return {
      us: {
        title: t('footer.us.title'),
        items: [
          {
            label: t('footer.us.work'),
            routeName: TrabajaConNosotros,
            show: storeGlobal.permisos.nosotros.showed,
          },
          {
            label: t('footer.us.blog'),
            routeName: BlogLanding,
            show: storeGlobal.permisos.blog.showed,
          },
        ],
      },
      social: {
        title: t('footer.social'),
        items: [
          {
            link: facebook,
            ariaLabel: 'Link Ski&Night Facebook',
            icon: 'fa-brands fa-facebook-f fa-xl',
          },
          {
            link: instagram,
            ariaLabel: 'Link Ski&Night Instragram',
            icon: 'fa-brands fa-instagram fa-xl',
          },
          {
            link: twitter,
            ariaLabel: 'Link Ski&Night Twitter',
            icon: 'fa-brands fa-twitter fa-xl',
          },
          {
            link: linkedin,
            ariaLabel: 'Link Ski&Night Linkedin',
            icon: 'fa-brands fa-linkedin fa-xl',
          },
          {
            link: tiktok,
            ariaLabel: 'Link Ski&Night Tiktok',
            icon: 'fa-brands fa-tiktok fa-xl',
          },
          {
            link: youtube,
            ariaLabel: 'Link Ski&Night Youtube',
            icon: 'fa-brands fa-youtube fa-xl',
          },
        ],
      },
    };
  });

  function handleAvisoLegalClick() {
    router.push({ name: 'AvisoLegal' });
  }

  function goCondicionesGenerales() {
    router.push({ name: 'TerminosCondiciones' });
  }

  function goPoliticaCookies() {
    router.push({ name: 'PoliticaCookies' });
  }

  function goPoliticaPrivacidad() {
    router.push({ name: 'PoliticaPrivacidad' });
  }

  function goFAQs() {
    router.push({ name: FAQS });
  }
</script>

<style lang="scss" scoped>
  .footer-landing.text-white,
  .footer-landing .text-white,
  .footer-landing .item-social a i {
    color: var(--landing-footer-color) !important;
  }

  .footer.footer-landing {
    background-color: var(--landing-footer-bg);
    font-family: var(--landing-text-font, inherit);

    span,
    a,
    p,
    div {
      font-family: var(--landing-text-font, inherit);
    }
  }

  .footer {
    width: 100%;
    background-color: var(--bs-footer);

    .content,
    .copyright {
      margin: auto;
    }

    @media (max-width: 768px) {
      padding-bottom: 50px;
    }
  }

  .footer-san {
    width: 100%;
    background-color: var(--bs-footer);

    .content,
    .copyright {
      max-width: 1440px;
      margin: auto;
    }
  }

  .item-social {
    display: flex;
    align-items: center;
    justify-content: center;
    a {
      i {
        color: var(--bs-white);
      }
    }
    padding: 8px;
  }

  .item {
    margin-top: 0.8rem !important;
    cursor: pointer;

    .title {
      display: inline-block;
      &:hover {
        transform: scale(1.05);
        transition: transform 0.1s ease-in-out;
      }
    }
  }

  .itemFirstFooter {
    padding-top: 2.5rem;
    padding-bottom: 0.75rem;

    .logo-transvia {
      height: 20px;
      width: auto;
      display: block;

      @media (max-width: 768px) {
        margin: 0 auto;
      }
    }
  }

  .verticalBars {
    margin-left: 1.1rem;
  }
</style>
